import "./google-fonts-1768245371125.css"
import "./main.scss"

import "blissfuljs"
const { $, $$ } = window

import { Gallery } from "bliss-gallery"
import { Navigation } from "./js/navigation.js"
import ProductFilter from "./js/productFilter"
import { ToggleElements } from "./js/toggleElements"

$.ready().then(() => {
  /*
   * Navigation
   * ==========
   */

  new Navigation()

  new ToggleElements()

  new ProductFilter()

  /*
   * Gallery
   * =======
   */

  const galleries = $$(".gallery")

  galleries.forEach((el) => {
    const galleryThumbs = $(".gallery__thumbs", el)
    const amountOfSlides = $$("[data-slide]", el).length
    let thumbEl = null

    // generate pagination if there are more the slider has more than one slide
    if (amountOfSlides > 1) {
      for (let i = 0; i <= amountOfSlides - 1; i++) {
        thumbEl = document.createElement("a")
        thumbEl.setAttribute("data-thumb", "")
        thumbEl.setAttribute("href", "")
        galleryThumbs.appendChild(thumbEl)
      }
    } else {
      galleryThumbs.classList.add("hide")
    }

    new Gallery(el, {
      autoPlay: true,
      interval: 8000,
      createThumbs: thumbEl != null,
    })
  })
  const slideshow = $$(".testimonialslider .slideshow")
  slideshow.forEach((element) => {
    new Gallery(element, {
      autoPlay: true,
      createThumbs: true,
    })
  })
  const slides = $$(".testimonialslider .slide-container")
  if (slides.length === 1) {
    $(".testimonialslider").classList.add("slideshow-false")
  }
})
